import { css } from "@emotion/react";

import { MEDIA_QUERY_FOR_PC } from "../../constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "../../constants/mediaQueryForSp";

export const headerStyle = css`
  color: #1e1e1e;
  display: flex;
  flex-wrap: wrap;
  font-weight: 500;

  ${MEDIA_QUERY_FOR_PC} {
    gap: 8px;
    font-size: 16px;
    line-height: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    flex-direction: column;
    font-size: 14px;
    line-height: 20px;
    row-gap: 10px;
  }
`;

// header 直下の 要素全ての適用すべきスタイル
const headerChildrenCommonStyles = css`
  ${MEDIA_QUERY_FOR_PC} {
    flex-shrink: 0;
  }
`;

export const dateStyle = css`
  ${headerChildrenCommonStyles};
`;

export const openStyle = css`
  ${headerChildrenCommonStyles};

  ${MEDIA_QUERY_FOR_SP} {
    display: none;
  }
`;

export const timeStyle = css`
  ${headerChildrenCommonStyles};
  ${MEDIA_QUERY_FOR_PC} {
    margin-right: auto;
  }

  ${MEDIA_QUERY_FOR_SP} {
    display: none;
  }
`;

export const labelWrapperStyle = css`
  ${headerChildrenCommonStyles};
`;

const threeLineClamp = css`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const titleStyle = css`
  ${threeLineClamp};
  color: #1e1e1e;
  font-weight: 700;
  letter-spacing: 0;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 16px;
    line-height: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const artistsStyle = css`
  ${threeLineClamp};
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
`;
